angular.module("ainapp")
    .controller("userMenuController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "FontawsomeService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, FontawsomeService) {


            $scope.PageName = "User Menu";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Levels = [
                {
                    Id: 1,
                    Name: "Group"
                },
                {
                    Id: 2,
                    Name: "Link"
                }
                ]

            $scope.Pages = [];
            angular.forEach($scope.PageList, function (e) {
                angular.forEach(e.Pages, function (a) {
                    $scope.Pages.push(a);
                })
            })

            $scope.switchTab = function (tab, type) {
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.Menu.UserId = tab;
                $scope.ktl.dataSource.read();
            }


            $scope.init = function () {

                $scope.UserPRole = {
                    UserRoleId: "",
                    PageName: "",
                    IsSelectedInActive: false,
                    IsSelectedActive: true,
                }

                $scope.IconsArray = FontawsomeService.getFaIcons();

                $scope.Users = [];
                MainService.EmployeeUsersInDropDown().then(function (response) {
                    $scope.Users = response.data;
                    if (response.data != null) {
                        $scope.switchTab(response.data[0].Id, response.data[0].Employee.Name);
                    }
                });

                $scope.ViewVal = 0;
                $scope.Load = false;

                $scope.Menu = {
                    Icon: "",
                    UserId: "",
                    ParentId: "",
                    Name: "",
                    Link: "",
                    Location: "",
                    Level: 1,
                    Order: 0,
                    IshideSideMenu: false,
                    IsNewTab: false,
                }


            }
            $scope.init();

            $scope.showForm = function () {
                $('#addForm').modal('show');
            }

            $scope.selectIcon = function (d) {
                $scope.Menu.Icon = d;
            }


            $scope.treelistOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {

                            if ($scope.Menu.UserId > 0) {
                                MainService.UserMenusInKendoTree($scope.Menu.UserId).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success([]);
                                    toastr.error("NetworkError");
                                })
                            } else {
                                o.success([]);
                            }
                        },
                    },
                    schema: {
                        model: {
                            id: "Id",
                            parentId: "ParentId",
                            fields: {
                                ParentId: {
                                    field: "ParentId",
                                    nullable: true
                                },

                                Name: {
                                    type: "string"
                                },
                                Icon: {
                                    type: "string"
                                },
                                Link: {
                                    type: "string"
                                },
                                Location: {
                                    type: "string"
                                },
                                Level: {
                                    type: "number"
                                },
                                IshideSideMenu: {
                                    type: "boolean"
                                },
                                IsNewTab: {
                                    type: "boolean"
                                },
                                "User.UserName": {
                                    type: "string"
                                },
                                "Order": {
                                    type: "number"
                                },
                            },
                            expanded: false
                        }
                    }
                },

                editable: false,
                toolbar: ["excel"],
                height: 600,
                //resizable: true,
                sortable: true,
                //scrollable: true,
                filterable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Name",
                        title: "Name",
                                        },
                    {
                        field: "Icon",
                        title: "Icon",
                        template: "<i class='fa {{dataItem.Icon}}'></i>"
                                        },
                    {
                        field: "Link",
                        title: "Link",
                                        },
                    {
                        field: "Level",
                        title: "Level",
                                        },
                    {
                        field: "Order",
                        title: "Order",
                                        },
                    {
                        field: "Location",
                        title: "Location",
                                        },
                    {
                        field: "IshideSideMenu",
                        title: "Is Hide Side Menu",
                        width: "100px",
                        template: "<p ng-if='dataItem.IshideSideMenu'> Yes </p> <p ng-if='!dataItem.IshideSideMenu'> No </p>"
                        },
                    {
                        field: "IsNewTab",
                        title: "Is New Tab",
                        width: "100px",
                        template: "<p ng-if='dataItem.IsNewTab'>Yes </p> <p ng-if='!dataItem.IsNewTab'> No </p>"
                        },
                    {
                        field: "User.EmployeeName",
                        title: "Employee",
                                        },
                    {
                        title: "Options",
                        template: "<button ng-if='!dataItem.ParentId > 0' class=' btn-default btn-sm fa fa-plus' ng-click='ShowAddModel(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-pencil' ng-click='ShowEditModel(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccount(dataItem)'></button>  ",
                        width: '100px'
                        },

                                    ],
            };




            $scope.ShowAddModel = function (data) {
                $scope.selectedRow = data;
                $scope.Menu.ParentId = data.Id;
                $('#addForm').modal('show');
            }


            $scope.ShowEditModel = function (data) {
                $scope.Menu = data;
                $('#addForm').modal('show');
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccount = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteUserMenu($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $scope.ktl.dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.error(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.saveMenu = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.AddUserMenu($scope.Menu).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $('#addForm').modal('hide');

                        $scope.Menu = {
                            Icon: "",
                            UserId: "",
                            ParentId: "",
                            Name: "",
                            Link: "",
                            Location: "",
                            Level: 1,
                            Order: 0,
                            IshideSideMenu: false,
                            IsNewTab: false,
                        }
                        $scope.selectedRow = {};

                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                    } else {
                        toastr.error("Failed");
                    }

                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }









      }]);
